var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('v-container',{staticClass:"my-5"},[_c('h1',{staticClass:"title"},[_vm._v("Fehler: "+_vm._s(this.$route.query.code))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }